import React from 'react';
import {useNavigation} from '@react-navigation/native';

import {closeFinesFlow, openFinesModal, useFinesFlowStage} from '../../../context/finesFlow';
import {FinesReminderModal} from '../FinesReminderModal';
import {FinesReminderToast} from '../FinesReminderToast';

export function GlobalFinesReminder() {
  const stage = useFinesFlowStage();
  const navigation = useNavigation();

  function handleWantToKnowMore() {
    closeFinesFlow();
    navigation.navigate('VehicleDebits');
  }

  return (
    <>
      <FinesReminderToast
        visible={stage === 'toast'}
        onTap={openFinesModal}
        onAutoDismiss={closeFinesFlow}
      />
      <FinesReminderModal
        isOpen={stage === 'modal'}
        onClose={closeFinesFlow}
        onWantToKnowMore={handleWantToKnowMore}
      />
    </>
  );
}
